export default "__VITE_ASSET__CDuiWem6__"